import React from "react";

const Java_Count_Vowels = () => {
  return (
    <div>
      <h1>Java Count Vowels</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Count Vowels in Java.</p>
    </div>
  );
};

export default Java_Count_Vowels;
